import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";

interface AutoCategorizeConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const AutoCategorizeConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: AutoCategorizeConfirmationModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Auto-categorize transactions?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-sm t-text-text-60">
            Inkle AI will attempt to categorize all uncategorized transactions
            and recategorize any previously AI-categorized ones that haven't
            been confirmed yet, within the selected date range.
            <br />
            <br />
            This won't affect transactions that have already been manually
            categorized or confirmed.
            <br />
            <br />
            Do you want to proceed?
          </div>
        </Modal.Body>
        <Modal.Footer className="t-flex t-justify-end t-gap-3">
          <Button onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            customType="primary"
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
